/**
 * Geo helpers — haversine distance + anonymous visitor id.
 */

export function haversineKm(lat1, lng1, lat2, lng2) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

const VID_KEY = "matchup_anon_visitor_id";

export function getOrCreateVisitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      v = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now().toString(36));
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return null;
  }
}

const POS_KEY = "matchup_last_position";

export function loadCachedPosition() {
  try {
    const raw = localStorage.getItem(POS_KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (Date.now() - (p.ts || 0) > 24 * 3600 * 1000) return null; // 24h freshness
    return p;
  } catch {
    return null;
  }
}

export function saveCachedPosition(lat, lng, city) {
  try {
    localStorage.setItem(POS_KEY, JSON.stringify({ lat, lng, city, ts: Date.now() }));
  } catch {}
}
